import { SVGProps } from "react";

const Attach = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={14}
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.3334 5.52403L8.4762 8.38121C7.68721 9.17019 6.40801 9.17019 5.61903 8.38121C4.83004 7.59222 4.83004 6.31302 5.61903 5.52403L9.42859 1.71447C10.7436 0.399492 12.8756 0.399492 14.1905 1.71447C15.5055 3.02945 15.5055 5.16145 14.1905 6.47642L9.42859 11.2384C7.58762 13.0793 4.60282 13.0793 2.76185 11.2384C0.920886 9.39741 0.920886 6.41261 2.76185 4.57164L6.57142 0.762079V0.762079"
      stroke="currentColor"
      strokeWidth={1.4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Attach;
